<div class="col-sm-12 offset-md-1 col-md-10  mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="form-back  h4 my-4">
        <a *ngIf="getEmptyStringChecker(userLoginOptions.forget_back_url)"
            [routerLink]="['/'+this.slug+ '/'  + userLoginOptions.forget_back_url]">&#8592; Back</a>
    </div>
    <div class="form-heading-section mt-4">
        <h2 *ngIf="getEmptyStringChecker(userLoginOptions.name)">
            Forgot Password - {{userLoginOptions.name}}</h2>
        <p class="form-sub-heading">
            Don't worry we've got you covered.
        </p>
        <p class="form-tagline"><small>Proceed with Email or Phone Number</small></p>
        <!-- <p class="text-center forgot-pass-info"><small>Password reset link will be sent to your Email
                id.</small></p> -->
    </div>
    <div class="container ml-lg-5 pl-lg-5">
        <div class="row p-lg-2">
            <div class="btn-group togglebtngrp mb-4 ml-1 col-lg-9 col-md-12 col-sm-12" role="group"
                aria-label="Login options" *ngIf="forgot_password.tabViewData.selected_tab!=2">
                <button type="button" class="btn btn-outline-primary left-btn"
                    (click)="this.forgot_password.userid_data.toggleLoginType(false)"
                    [class.active]="!this.forgot_password.userid_data.is_email">
                    Phone
                </button>

                <button type="button" class="btn btn-outline-primary right-btn"
                    (click)="this.forgot_password.userid_data.toggleLoginType(true)"
                    [class.active]="this.forgot_password.userid_data.is_email">
                    Email
                </button>
            </div>
        </div>

        <div class="form-div my-4">
            <ng-container *ngIf="forgot_password.tabViewData.selected_tab==0">
                <form #forgotPasswordForm="ngForm" (ngSubmit)="userIdFormSubmit()" accept-charset="UTF-8"
                    *ngIf="this.forgot_password.userid_data.toggle_Reset">
                    <div class="form-group row">
                        <div class="input-div col-sm-12 col-lg-9 col-md-12 ml-1">
                            <userid-input class="col-12"
                                [userid_data]="this.forgot_password.userid_data"></userid-input>
                            <!-- <small class="form-error-msg text-center">*Email required</small> -->
                        </div>
                        <!-- <div class="col-sm-1 m-auto"></div> -->
                    </div>
                    <div class="form-group row mx-md-4 ml-sm-2 ml-md-3">
                        <div class="m-3">
                            <div id="recaptcha-div2">
                                <re-captcha *ngIf="forgot_password.recaptchaData.recaptcha_Reset"
                                    class="recaptcha ng-valid" name="recaptcha" matInput style="display: inline-block;"
                                    (resolved)="resolved($event)" [(ngModel)]="forgot_password.body.recaptcha"
                                    #recaptcha="ngModel" [siteKey]="sitekey" required>
                                </re-captcha>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-9 col-sm-12">
                            <div class="form-submit-button mt-5 ml-lg-2">
                                <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                                    [disabled]="!forgotPasswordForm.valid || isPosting() || !forgot_password.userid_data.continueButtonCondition()">
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>

            <ng-container *ngIf="forgot_password.tabViewData.selected_tab==1">
                <div class="form-heading-section mt-4">
                    <p class="form-sub-heading">
                        We have sent an OTP on
                    </p>
                    <h2>{{forgot_password.body.userid}}</h2>
                </div>
                <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
                    <div class="form-group row col-lg-10 col-md-12">
                        <otp-input class="col-12" [isPrimeNg]="false" [otp_data]="forgot_password.otp_data"
                            (otp_resend)="otp_resend()">
                        </otp-input>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-12 ml-1" for="password">New Password*</label>
                        <div class="input-div col-sm-12 pr-0">
                            <div class="input-group col-md-12 col-lg-9">
                                <input id="password" name="password"
                                    [type]="forgot_password.password_input.isPassword?'password':'text'"
                                    class="m-0 form-control input-of-input-icon ml-0" aria-describedby="password"
                                    placeholder="********" [(ngModel)]="forgot_password.tokenBody.e_password"
                                    #password="ngModel" minlength="8"
                                    [class.form-input-error]="(password.invalid && (password.dirty || password.touched)) && (password.errors.required)"
                                    [class.form-input-success]="(!password.invalid && (password.dirty || password.touched)) && !(password.errors?.required || password.errors?.minlength)"
                                    required>
                                <div class="input-group-append">
                                    <span class="input-group-text icon-of-input-icon">
                                        <i toggle="#password-field" role="button" class="text-dark fa fa-fw"
                                            [class.fa-eye]="forgot_password.password_input.isPassword"
                                            [class.fa-eye-slash]="!forgot_password.password_input.isPassword"
                                            [class.form-input-error]="(password.invalid && (password.dirty || password.touched)) && (password.errors.required)"
                                            [class.form-input-success]="(!password.invalid && (password.dirty || password.touched)) && !(password.errors?.required || password.errors?.minlength)"
                                            (click)="forgot_password.password_input.toggleType()">
                                        </i>
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div *ngIf="(password.invalid && (password.dirty || password.touched))" class="col-sm-12">
                            <div *ngIf="password.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password is required.
                            </div>
                            <div *ngIf="password.errors.minlength" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Minimum length should be of 8 characters.
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-12 ml-1" for="password">Confirm Password*</label>
                        <div class="input-div col-sm-12 pr-0">
                            <div class="input-group col-md-12 col-lg-9">
                                <input id="password" name="confirmpassword"
                                    [type]="forgot_password.password_input.isPassword?'password':'text'"
                                    class="m-0 form-control input-of-input-icon ml-0" aria-describedby="password"
                                    placeholder="********" [(ngModel)]="forgot_password.tokenBody.confirm_password"
                                    #confirmpassword="ngModel" minlength="8"
                                    [class.form-input-error]="(confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched)) && (confirmpassword.errors.required)"
                                    [class.form-input-success]="(!confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched)) && !(confirmpassword.errors?.required || confirmpassword.errors?.minlength)"
                                    required>
                            </div>
                        </div>

                        <div *ngIf="(confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched))"
                            class="col-sm-12">
                            <div *ngIf="confirmpassword.errors.required" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Confirm Password is required.
                            </div>
                        </div>
                        <div *ngIf="(confirmpassword.dirty || confirmpassword.touched)" class="col-sm-12">

                            <div *ngIf="forgot_password.tokenBody.e_password != forgot_password.tokenBody.confirm_password"
                                class="col-sm-12 alert alert-danger m-2" role="alert">
                                Password and Confirm Password do not match.
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-9 col-sm-12">
                            <div class="form-submit-button ml-lg-2 my-3">
                                <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                                    [disabled]="isPosting() || !otpForm.valid">
                                    Reset Password
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="forgot_password.tabViewData.selected_tab==2">
                <div class="form-heading-section mt-4">
                    <h2 class="text-center forgot-pass-info">Your Password has been reset successfully!</h2>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="form-submit-button mt-5">
                            <button type="button" class="btn btn-primary font-weight-bold text-white p-2"
                                [disabled]="isPosting()"
                                [routerLink]="['/'+ this.slug+userLoginOptions.forget_back_url]">
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="mt-3 mx-2">
                <div class="row">
                    <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                </div>
                <app-error-messages [api_result]="forgot_password.forgot_api_result"></app-error-messages>
                <app-error-messages [api_result]="forgot_password.otp_data.otp_api_result">
                </app-error-messages>
            </div>
        </div>
    </div>

    <div class="footer-copyright-section mt-4">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>

</div>